<highcharts-chart class="histogram-container" [options]="chartConfig$ | async" [style.visibility]="!noData ? null : 'hidden'" />
@if (noData) {
    <loading-and-error class="no-data" [hasNoData]="noData" />
}
